import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';

export function ListHeading({ title }: { title: TranslationKey }): JSX.Element {
	return (
		<Text variant="heading" as="h2" size="small" className="mb-6 mt-0 pb-0 text-content-primary">
			<Translate value={title} />
		</Text>
	);
}
